<app-header></app-header>

<div class="page-title-area contact-bg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li>Contact</li>
            </ul>
            <h2>Contact C.M.D.T.A.M.P</h2>
        </div>
    </div>
</div>

<div class="contact-info-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-envelope'></i>
                    </div>
                    <h3>Email</h3>
                    <p><a href="mailto:office@cmdtamp.ro">office@cmdtamp.ro</a></p>
                    <p><a href="mailto:reclamatii@cmdtamp.ro">reclamatii@cmdtamp.ro</a></p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-map'></i>
                    </div>
                    <h3>Adresa</h3>
                    <p><a href="https://goo.gl/maps/puPsLtJ77mYDT1hJ9" target="_blank">Str. Washington 8 – 10 Sector 1
                            Bucuresti</a>
                    </p>
                    <p> Metrou: statie Piata Victoriei</p>
                    <p>Tramvai: 34, 46, 5, 1, 10</p>
                    <p>Autobuz: 182, 282, 330, 335, 783, 131, 301, 331, 381, 300</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>
                    <h3>Telefoane</h3>

                    <p><a href="tel:0212302980">Centrala: 0212302980</a></p>
                    <p><a href="tel:0212305923">Programari: 0212305923</a></p>
                    <p><a href="tel:0212305924">Programari: 0212305924</a></p>
                    <p><a href="tel:0212305929">Programari: 0212305929</a></p>
                    <p><a href="tel:0212300402">Dispecerat: 0212300402</a></p>
                    <p><a href="tel:0213180261">Pediatrie: 0213180261</a></p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>
                    <h3>Program cu publicul : </h3>

                    <p><a href="tel:0212302980">Programari 07:00 – 21:00 </a></p>
                    <p><a href="tel:0212305923">Evidenta pacienti 07:00 – 21:00 </a></p>
                    <p><a href="tel:0212305924">Cabinete Medicale 07:00 – 21:00 </a></p>
                    <p><a href="tel:0212305929">Secretariat 08:00 – 14:00</a></p>
                </div>
            </div>


            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>
                    <h3>Program audiente : </h3>

                    <p>Director General : Luni       10:00 – 12:00</p>
                    <p>Director Medical : Marti 11:00 – 13:00</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-error-alt' ></i>
                    </div>


                    <p>Persoanele care efectuează raportări în sensul Legii nr. 361/2022 privind protecţia avertizorilor
                        în interes public, cu modificările ulterioare, au la dispoziție adresa de email
                        <a href="mailto:avertizori.integritate@cmdtamp.ro">avertizori.integritate@cmdtamp.ro</a>
                    </p>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="contact-area pb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Contactează-ne</span>
            <h2>Scrie-ne un mesaj</h2>
            <p>Pentru orice solicitare, lasă-ne un mesaj și îți vom raspunde în cel mai scurt timp posibil.</p>
        </div>
        <div class="contact-form">
            <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group">
                            <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel"
                                class="form-control" id="name" placeholder="Nume Prenume">
                            <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                <div *ngIf="name.errors.required">Numele este obligatoriu.</div>
                                <div *ngIf="name.errors.minlength">Numele are un minim de {{
                                    name.errors.minlength.requiredLength }} caractere.</div>
                                <div *ngIf="name.errors.maxlength">Numele are un maxim de 50 de caractere.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group">
                            <input required ngModel name="email" type="text" #email="ngModel" class="form-control"
                                id="email" placeholder="Adresă de E-mail">
                            <div class="alert alert-danger" *ngIf="email.touched && !email.valid">Adresa de Email este
                                obligatorie.</div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group">
                            <input required ngModel name="number" type="text" #number="ngModel" class="form-control"
                                id="number" placeholder="Număr de telefon">
                            <div class="alert alert-danger" *ngIf="number.touched && !number.valid">Telefonul este
                                obligatoriu.</div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group">
                            <input required ngModel name="subject" type="text" #subject="ngModel" class="form-control"
                                id="subject" placeholder="Subiect">
                            <div class="alert alert-danger" *ngIf="subject.touched && !subject.valid">Telefonul si
                                Subiectul sunt obligatorii.</div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="form-group">
                            <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5"
                                class="form-control" placeholder="Mesaj..."></textarea>
                            <div class="alert alert-danger" *ngIf="message.touched && !name.valid">Mesajul este
                                obligatoriu.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid"><i
                                class='bx bx-paper-plane icon-arrow before'></i><span class="label">Trimite
                                Mesajul</span><i class="bx bx-paper-plane icon-arrow after"></i></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="contact-bg-image"><img src="assets/img/map.png" alt="image"></div>
</div>

<div id="map">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2847.9138358396685!2d26.08887319190698!3d44.45543801561158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b202009c37a5ab%3A0x3012ae90f11eba52!2sStrada%20Washington%208-10%2C%20Bucure%C8%99ti%20011794!5e0!3m2!1sro!2sro!4v1631699087522!5m2!1sro!2sro"
        style="border:0;" loading="lazy"></iframe>
</div>
